import moment from 'moment';

require('bootstrap-datepicker');

Vue.component('date-picker', {
    props: ['value'],

    data () {
        return {
            object: null
        };
    },

    mounted () {
        var _this = this;

        if (this.value != undefined) {
            this.$el.value = this.value;
        }

        $(this.$el).datepicker({
            beforeShow: function (input) {
                $(input).css({"position": "relative", "z-index": 999999});
            },

            autoclose: true,

            format: "dd-mm-yyyy",
        });

        $(this.$el).on('changeDate', (e) => {
            _this.$emit('on-date-selected', moment(e.date).format("DD-MM-YYYY"));
        });
    },

    watch: {
        value: function(newVal, oldVal) {
            this.$el.value = newVal;
        }
    }
});
